import type { PartyType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  type: PartyType;
};

export const PartyTypeCell = ({ type }: Props) => {
  const { t } = useResource();

  return <>{t(Resources.Common.PartyTypeShortcut[type])}</>;
};
